import React from 'react';

import useClasses from '../../../hooks/useClasses';
import FormikWrapper from './FormikWrapper';
import Fields from './Fields';
import Submit from './Submit';

import './style.scss';

interface Props {
  title?: string;
  className?: string;
  children: React.ReactNode;
}

interface BuddiesFormSubComponent {
  FormikWrapper: typeof FormikWrapper;
  Fields: typeof Fields;
  Submit: typeof Submit;
}

const BuddiesForm: React.FC<Props> & BuddiesFormSubComponent = (props) => {
  const {
    title,
    className,
    children,
  } = props;

  const { buildClass, joinClasses } = useClasses('BuddiesForm');

  return (
    <div className={joinClasses(buildClass(), className)}>
      {title && (
        <div className={buildClass('title')}>
          <h2>{title}</h2>
        </div>
      )}

      {children}
    </div>
  );
};

BuddiesForm.FormikWrapper = FormikWrapper;
BuddiesForm.Fields = Fields;
BuddiesForm.Submit = Submit;

export default BuddiesForm;
